var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloodtype = function SvgBloodtype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22q-3.425 0-5.713-2.35Q4.001 17.3 4 13.8q0-2.5 1.987-5.438Q7.976 5.426 12 2q4.025 3.425 6.012 6.363Q20 11.299 20 13.8q0 3.5-2.288 5.85T12 22m0-1.5q2.8 0 4.65-1.913 1.85-1.912 1.85-4.795 0-1.966-1.663-4.48Q15.176 6.802 12 4 8.824 6.8 7.162 9.313T5.5 13.791q0 2.883 1.85 4.795Q9.2 20.501 12 20.5m-3-3h6V16H9zm2.25-2.5h1.5v-2.25H15v-1.5h-2.25V9h-1.5v2.25H9v1.5h2.25z"
  })));
};
export default SvgBloodtype;